import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit'
import { ReactNode } from 'react'

export interface CartItem {
	id?: string | null
	image?: string | null
	name?: string | null
	points?: number | null
	color?: string | null
	size?: string | null
	item_id?: string | null
	product_id?: string | null
	quantity?: number | null
	category?: string | null
	isOutOfStock?: boolean | null
}

export interface CartState {
  cartItems: CartItem[],
  cartDialog: boolean,
}

const initialState: CartState = {
 	cartItems: [],
 	cartDialog: false,
}

const reducers = {
	setCartItems(state: CartState, { payload }: PayloadAction<CartItem[]>) {
		state.cartItems = payload
	},
  cleanCart() {
  	return initialState
  },
  showCartDialog(state: CartState,) {
  	state.cartDialog = true
  },
  toggleDialog(state: CartState) {
  	state.cartDialog = !state.cartDialog
  },
  hideCartDialog(state: CartState,) {
  	state.cartDialog = false
  }
}

const Cart = createSlice({
  name: 'cart',
  initialState,
  reducers
})

const CUSTOM_ACTIONS = {
  addCartStorage: createAction<CartItem>('store/add-cart-storage'),
  removeCartStorage: createAction<string>('store/remove-cart-storage'),
  loadItemsFromStorage: createAction('store/load-from-storage'),
  clearItemsFromStorage: createAction('store/clear-from-storage'),
}

export const CartActions =  { ...Cart.actions, ...CUSTOM_ACTIONS }
export default Cart.reducer
